module.exports = __webpack_public_path__ + "static/media/unidadfactura.58bbe09b.png";